module.exports = __webpack_public_path__ + "img/invite_button.e6bea2b6.png";